import { BaseService } from "services/_baseService";
import { Task } from "interfaces/entities/task.model";

class TasksAdminService extends BaseService<Task> {
    constructor() {
        super(`tasks`);
    }
}

export default new TasksAdminService()